<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import type { InputGroupButtonVariants } from './input-group-variants'
  import type { ButtonVariants } from '../button'
  import { cn } from '../../../lib/utils'
  import { Button } from '../button'
  import { inputGroupButtonVariants } from './input-group-variants'

  interface InputGroupButtonProps {
    variant?: ButtonVariants['variant']
    size?: InputGroupButtonVariants['size']
    class?: HTMLAttributes['class']
  }

  const props = withDefaults(defineProps<InputGroupButtonProps>(), {
    size: 'icon-xs',
    variant: 'ghost'
  })
</script>

<template>
  <Button
    :data-size="props.size"
    :variant="props.variant"
    :class="cn(inputGroupButtonVariants({ size: props.size }), props.class)"
  >
    <slot />
  </Button>
</template>
